var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    fill: "#AA151B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 3,
    height: 1,
    fill: "#F1BF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,1) scale(0.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -10,
    width: 10,
    height: 20,
    fill: "#AA151B",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: -5,
    width: 5,
    height: 10,
    fill: "#FFFFFF",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1.2,
    fill: "#F1BF00",
    stroke: "#000",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsFlag);
export default __webpack_public_path__ + "static/media/esFlag.baa95f6ac1c20ee64bc70010496f4675.svg";
export { ForwardRef as ReactComponent };